module.exports = __webpack_public_path__ + "static/media/adogtame.7a497cfa.jpg";